import React, { useCallback, useEffect, useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
export default function useDispatchConfirmation() {
  const [request, setRequest] = useState(null);
  const pending = useRef(null);
  useEffect(
    () => () => {
      pending.current?.(false);
      pending.current = null;
    },
    []
  );
  const confirm = useCallback(
    (error) =>
      new Promise((resolve) => {
        pending.current?.(false);
        pending.current = resolve;
        setRequest(error);
      }),
    []
  );
  const close = (accepted) => {
    const resolve = pending.current;
    pending.current = null;
    setRequest(null);
    resolve?.(accepted);
  };
  const details = request?.details || {};
  const excess = request?.confirmation === "confirmExcessReturn";
  const oldDate = request?.confirmation === "confirmOldDate";
  const dialog = (
    <Dialog
      header={
        excess
          ? "Revisar cantidades devueltas"
          : oldDate
          ? "Confirmar fecha de operación"
          : "Confirmar cambio"
      }
      visible={!!request}
      onHide={() => close(false)}
      className="sd-confirmation"
      style={{ width: "44rem", maxWidth: "95vw" }}
      draggable={false}
      dismissableMask={false}
      footer={
        <div className="sd-toolbar">
          <Button
            label="Volver y corregir"
            className="p-button-outlined p-button-secondary"
            onClick={() => close(false)}
            autoFocus
          />
          <Button label="Confirmar y guardar" onClick={() => close(true)} />
        </div>
      }
    >
      <p>{request?.message}</p>
      {excess ? (
        <>
          <p>
            Comparación para este destino durante los 30 días anteriores a la
            fecha de operación.
          </p>
          <div
            className="sd-lines sd-table-scroll"
            role="region"
            aria-label="Detalle de la confirmación"
            tabIndex={0}
          >
            <table>
              <thead>
                <tr>
                  <th>Insumo</th>
                  <th>Entregado</th>
                  <th>Ya devuelto</th>
                  <th>Esta devolución</th>
                  <th>Total devuelto</th>
                </tr>
              </thead>
              <tbody>
                {(details.items || []).map((item) => (
                  <tr key={item.code}>
                    <td>
                      {item.code}
                      <small>
                        {item.name} · {item.unit}
                      </small>
                    </td>
                    <td>{item.delivered}</td>
                    <td>{item.returned}</td>
                    <td>{item.requested}</td>
                    <td>
                      <strong>{item.totalReturned}</strong>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <p>
            Puede continuar si las cantidades son correctas. Su confirmación
            quedará registrada.
          </p>
        </>
      ) : oldDate ? (
        <dl>
          <dt>Fecha seleccionada</dt>
          <dd>{details.operationDate || "—"}</dd>
          <dt>Antigüedad</dt>
          <dd>{details.daysOld ?? "Más de 30"} días</dd>
        </dl>
      ) : null}
    </Dialog>
  );
  return { confirm, dialog };
}
